import { shimmer } from '@helpers/animation';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import styled, { css } from 'styled-components';

const baseContainer = css`
  background-color: ${brand.white};
  padding: 4px;
  border-radius: 4px;
  border: 1px solid ${brand.grey[80]};

  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  gap: 16px;
`;

const Container = styled.div`
  ${baseContainer};
`;

const LinkContainer = styled.a`
  ${baseContainer};
  color: ${brand.nearlyBlack};
`;

const Name = styled.span`
  ${fonts.helvetica['97-black-condensed']};
  font-size: 18px;
  text-transform: uppercase;
`;

const Code = styled.span`
  ${fonts.helvetica['87-heavy-condensed']};
  font-size: 14px;
  text-transform: uppercase;
  color: ${brand.grey[45]};
  margin-left: 8px;
`;

const Media = styled.div`
  flex: 0 0 48px;

  @media ${from(Device.TabletLarge)} {
    flex: 0 0 64px;
  }

  img {
    width: 100%;
  }
`;

const Content = styled.div`
  flex: 1 1 100%;
  padding: 15px 0px;
`;

const Quantity = styled.div`
  flex: 0 1 44px;
  text-align: center;

  ${fonts.helvetica['63-medium-extended']};
  letter-spacing: ${fonts.ls(50)};
  font-size: 14px;

  @media ${from(Device.TabletLarge)} {
    flex: 0 1 105px;
  }
`;

const SkeletonContainer = styled.div`
  ${baseContainer};
  ${shimmer};
`;

const SkeletonMedia = styled(Media)`
  background-color: ${brand.grey[85]};
  height: 48px;

  @media ${from(Device.TabletLarge)} {
    height: 64px;
  }
`;

export const ProductRowStyles = {
  Container,
  LinkContainer,
  Name,
  Code,
  Media,
  Content,
  Quantity,
  SkeletonContainer,
  SkeletonMedia,
};
